import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { Ulna } from './Ulna';
import { Muac } from './Muac';
import { NavigationButtons } from '../../shared/components/navigationButtons';
import { TypographyH1Bold } from '../estimatingRequirements/peng2018/style';

const AlternativeMeasures = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => setTabIndex(newValue);

  return (
    <Box sx={{ width: '100%', padding: 2 }}>
      <TypographyH1Bold
        align="center"
        gutterBottom
        sx={{ lineHeight: '1.875rem' }}
      >
        Alternative Height and BMI Measures
      </TypographyH1Bold>

      {/* Tab Navigation within the content box */}
      <Box
        sx={{
          maxWidth: 600,
          margin: '0 auto',
          marginBottom: 2,
          marginTop: '1.25rem'
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderRadius: 1,
            borderColor: '#fff',
            backgroundColor: '#e0f7fa',
            '.MuiTabs-indicator': { display: 'none' },
            '.Mui-selected': { backgroundColor: '#fff', color: '#002A3A' },
            '.MuiTab-root': {
              color: '#002A3A',
              textAlign: 'center',
              fontFamily: 'Brandon Grotesque',
              fontSize: '1rem',
              fontWeight: '450',
              lineHeight: 'normal',
              textTransform: 'uppercase',
              '&:not(.Mui-selected)': {
                backgroundColor: '#5BC2E74D',
                color: '#002A3A'
              }
            }
          }}
        >
          <Tab label="ULNA LENGTH" />
          <Tab label="MUAC" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      {tabIndex === 0 && <Ulna />}
      {tabIndex === 1 && <Muac />}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
        <NavigationButtons nextRoute={'/nextSteps'} nextDisabled={false} />
      </Box>
    </Box>
  );
};

export { AlternativeMeasures };
